"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathname$ = void 0;
var location_1 = require("./location$");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var selector = function (_a) {
    var pathname = _a.pathname;
    return pathname;
};
exports.pathname$ = new rxjs_1.BehaviorSubject(selector(location_1.location$.getValue()));
location_1.location$
    .pipe((0, operators_1.map)(selector), (0, operators_1.filter)(function (pathname) { return pathname !== exports.pathname$.getValue(); }))
    .subscribe(exports.pathname$);
